// A risk read named a factor context the published Watchlist no longer uses.
export const FACTOR_CONTEXT_CHANGED_EVENT = 'alphamizer:factor-context-changed';

// The request was superseded: the dashboard follows the published context
// instead of reporting a failure.
export const isFactorContextChangedError = (error) => (
    error?.status === 409 && error?.code === 'watchlist_factor_context_changed'
);
